import { LoadingOutlined, StarFilled, StarOutlined } from '@ant-design/icons';
import { forwardRef } from 'react';
import { colours } from 'utils/theme';
import styled from 'styled-components';

const Container = styled.div`
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.2s ease;
  color: ${props => (props.isFavourite ? colours.gold : colours.darkGrey)};
  &:hover {
    color: ${colours.gold};
  }
`;

export const FavouriteIconButton = forwardRef(
  ({ style, value, onClick, loading, ...rest }, ref) => {
    // Tooltip injects hover handlers and a ref via cloneElement; spread/forward
    // them or the wrapping Tooltip never triggers.
    if (loading) {
      return <LoadingOutlined ref={ref} style={style} {...rest} />;
    }
    return (
      <Container
        ref={ref}
        style={style}
        isFavourite={value}
        onClick={onClick}
        {...rest}
      >
        {value ? <StarFilled /> : <StarOutlined />}
      </Container>
    );
  }
);
